import PropTypes from 'prop-types';
import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const AgentStateContext = createContext();

export const useAgentState = () => {
  const context = useContext(AgentStateContext);
  if (!context) {
    throw new Error('useAgentState must be used within an AgentStateProvider');
  }
  return context;
};

export const AgentStateProvider = ({ children }) => {
  const [executedActions, setExecutedActions] = useState([]);

  const addExecutedAction = useCallback((action) => {
    // Add to the beginning of the array so newest are first
    setExecutedActions((prevActions) => [action, ...prevActions]);
  }, []);

  const clearActions = useCallback(() => {
    setExecutedActions([]);
  }, []);

  const value = useMemo(
    () => ({
      executedActions,
      addExecutedAction,
      clearActions,
    }),
    [executedActions, addExecutedAction, clearActions]
  );

  return <AgentStateContext.Provider value={value}>{children}</AgentStateContext.Provider>;
};

AgentStateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AgentStateContext;
